import React from 'react';
import PropTypes from 'prop-types';
import CategoryItem1 from './CategoryItem1';

export default class CategoryItem1List extends React.Component {
  static propTypes = {
    productCategories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        displayCategoryId: PropTypes.number.isRequired,
        itemCount: PropTypes.number.isRequired,
        disableMarketplaceBanner: PropTypes.bool,
      })
    ).isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func
  };

  onMouseOver(e) {
    if (this.props.onMouseOver) {
      this.props.onMouseOver();
      e.preventDefault();
    }
  }

  onMouseLeave(e) {
    if (this.props.onClose) {
      this.props.onClose();
      e.preventDefault();
    }
  }

  render() {
    let { show, productCategories } = this.props;

    let rows = productCategories.map((productCategory, index) => {
      return <CategoryItem1 key={index} productCategory={productCategory} {...this.props} />;
    });

    let display = 'none';
    if (show) {
      display = 'block';
    }

    return (
      <div
        className="categoryFirstLayer"
        style={{ display: display }}
        onMouseOver={::this.onMouseOver}
        onMouseLeave={::this.onMouseLeave}
      >
        {rows}
      </div>
    );
  }
}
